import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductInfo } from 'product/services/productInfo/client'
import { useProductCardStore } from 'product-card/hooks/useProductCard/useProductCard'
import { useEffect } from 'react'

/**
 * This hook is used to synchronize the product information with
 * the product card when productId changes (related products).
 */

export const useSyncProductInfo = () => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const productId = useProductCardStore((state) => state.productId)
	const product = useProductCardStore((state) => state.product)
	const setProduct = useProductCardStore((state) => state.setProduct)

	const { data } = useProductInfo({
		productId,
		country: countryISO,
		language: languageISO,
		enabled: productId !== product.id,
	})

	useEffect(() => {
		if (data) {
			setProduct(data)
		}
	}, [data, setProduct])
}
